import React from "react";
import ListBody from "./ListBody";
import DeleteResourceButton from "./DeleteResourceButton";
import { defineMessage, FormattedMessage } from "react-intl";
import NotSetValue from "./NotSetValue";
import { Table, TableCell, TableHead, TableRow } from "@mui/material";

const translations = {
    empty: defineMessage({
        id: "user_alias.empty",
        defaultMessage: "There are no aliases for this user"
    }),
    name: defineMessage({
        id: "user_alias.name",
        defaultMessage: "Name"
    }),
    owner_type: defineMessage({
        id: "user_alias.owner_type",
        defaultMessage: "Owner"
    }),
    owner_types: {
        CLIENT: defineMessage({
            id: "user_alias.CLIENT",
            defaultMessage: "Client",
        }),
        USER: defineMessage({
            id: "user_alias.USER",
            defaultMessage: "User",
        }),
    }
} as const;

type UserAliasesTableProps = {
    rows: any[];
    showOwnerType?: boolean;
    showDeleteButton?: boolean;
};

const UserAliasesTable: React.FC<UserAliasesTableProps> = ({
    rows,
    showOwnerType = false,
    showDeleteButton = true,
}) => {
    if (rows.length == 0) return <NotSetValue label={translations.empty} />;

    return (
        <Table>
            {showOwnerType && (
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <FormattedMessage {...translations.name} />
                        </TableCell>
                        <TableCell>
                            <FormattedMessage {...translations.owner_type} />
                        </TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
            )}
            <ListBody
                data={rows}
                header={["name"].concat(showOwnerType ? ["owner_type"] : []).concat("controlHeader")}
                renderers={{
                    owner_type: (val, _) => {
                        return <FormattedMessage {...translations.owner_types[val]} />;
                    },
                    controlHeader: (val, row) => {
                        if (!showDeleteButton) return null;
                        return <DeleteResourceButton resourceName="user_alias" id={row.id} />;
                    },
                }}
            />
        </Table>
    );
};

export default UserAliasesTable;
